import { PolymorphicButtonBase } from '@plato/ui/primitives/button';
import { cn } from '@plato/ui/util/classes';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PlatoBust } from '../avatar/plato-bust.tsx';
import { useAskPlato } from './ask-plato-provider.tsx';
import { AskPlatoConnectedTeaser } from './ask-plato-teaser.tsx';

/**
 * Mobile entry point: an avatar-sized Ask Plato button riding in the top app
 * bar beside global search, with the teaser bubble hanging below it and the
 * unread dot until the chat is first opened. Opens the full-screen takeover.
 * On desktop the entry point is `AskPlatoFab` instead.
 */
export function AskPlatoMobileTrigger(): ReactElement {
    const { t } = useTranslation('ask-plato');
    const { toggleAskPlato, showTeaser } = useAskPlato();

    return (
        <div className="relative shrink-0">
            <PolymorphicButtonBase
                aria-label={t('trigger')}
                onClick={() => {
                    toggleAskPlato('top_bar');
                }}
                className={cn(
                    'relative size-8 cursor-pointer rounded-full select-none',
                    'ring-1 ring-line-weak hover:ring-line active:ring-line-strong',
                )}
            >
                <PlatoBust speaking={false} blink={false} follow={false} />
                {showTeaser && (
                    <span
                        aria-hidden
                        className="absolute -top-0.5 -right-0.5 size-2.5 rounded-full bg-danger ring-2 ring-container"
                    />
                )}
            </PolymorphicButtonBase>
            <div className="absolute top-full right-0 mt-cozy">
                <AskPlatoConnectedTeaser tail="up" />
            </div>
        </div>
    );
}
